import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getAppLocationMode = createSelector(appSettingsState, (appSettings) => appSettings?.locationMode);
